import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAGT8nKQ9wZM3JoQ7MDP1sZxkTxrnryE44",
  authDomain: "morse-tech-solutions.firebaseapp.com",
  projectId: "morse-tech-solutions",
  storageBucket: "morse-tech-solutions.firebasestorage.app",
  messagingSenderId: "339592111863",
  appId: "1:339592111863:web:bd1a19d1075e8c3ac955f2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Export Firestore instance
export { db };